"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var sc = _interopRequireWildcard(require("./Switch.styles"));

function Switch(props) {
  var a11yText = props.a11yText,
      canPropagate = props.canPropagate,
      isChecked = props.isChecked,
      isDisabled = props.isDisabled,
      size = props.size,
      onChange = props.onChange,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "canPropagate", "isChecked", "isDisabled", "size", "onChange"]);
  return /*#__PURE__*/_react["default"].createElement(sc.Switch, (0, _extends2["default"])({
    "data-pka-anchor": "switch",
    role: "switch",
    a11yText: a11yText,
    "aria-checked": isChecked,
    canPropagate: canPropagate,
    isDisabled: isDisabled,
    onClick: onChange,
    size: size
  }, moreProps), /*#__PURE__*/_react["default"].createElement(sc.Underlay, null, /*#__PURE__*/_react["default"].createElement(sc.Knob, null)));
}

Switch.types = {
  size: constants.defaultSize
};
var propTypes = {
  /** Descriptive a11y text for assistive technologies. Typically required. */
  a11yText: _propTypes["default"].string,

  /** If click events are allowed to propagate up the DOM tree. */
  canPropagate: _propTypes["default"].bool,

  /** If the switch is on. */
  isChecked: _propTypes["default"].bool,

  /** If the switch is disabled. */
  isDisabled: _propTypes["default"].bool,

  /** Callback to be executed when the switch is toggled on or off. Typically required. */
  onChange: _propTypes["default"].func,

  /** Size of the switch. */
  size: _propTypes["default"].oneOf([Switch.types.size.SMALL, Switch.types.size.MEDIUM, Switch.types.size.LARGE])
};
var defaultProps = {
  a11yText: null,
  canPropagate: true,
  isChecked: false,
  isDisabled: false,
  onChange: function onChange() {},
  size: Switch.types.size.MEDIUM
};
Switch.displayName = "Switch";
Switch.propTypes = propTypes;
Switch.defaultProps = defaultProps;
var _default = Switch;
exports["default"] = _default;
//# sourceMappingURL=Switch.js.map